export default __webpack_public_path__ + "static/media/thumb-live-video.8aff8433.png";